import { render, staticRenderFns } from "./WxInboundGoods.vue?vue&type=template&id=df4af83c&scoped=true&"
import script from "./WxInboundGoods.vue?vue&type=script&lang=js&"
export * from "./WxInboundGoods.vue?vue&type=script&lang=js&"
import style0 from "./WxInboundGoods.vue?vue&type=style&index=0&id=df4af83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4af83c",
  null
  
)

export default component.exports